export default "__VITE_ASSET__D_jZk_uL__"